import { render, staticRenderFns } from "./EventSignatureClient.vue?vue&type=template&id=79096e36&"
import script from "./EventSignatureClient.vue?vue&type=script&lang=js&"
export * from "./EventSignatureClient.vue?vue&type=script&lang=js&"
import style0 from "./EventSignatureClient.vue?vue&type=style&index=0&id=79096e36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports